<template>
  <b-row>
    <b-col cols="12">
      <form-prebid-partner />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormPrebidPartner from './FormPrebidPartner.vue'

export default {
  components: {
    BRow,
    BCol,
    FormPrebidPartner,
  },
}
</script>
